import { useIntl } from "react-intl";

import { GenericErrorMessage } from "foundations/Error/GenericErrorMessage";

interface AccessDeniedErrorProps {
  message?: string;
}

export function AccessDeniedError(props: AccessDeniedErrorProps) {
  const intl = useIntl();

  return (
    <GenericErrorMessage
      type="error"
      title={intl.formatMessage({
        defaultMessage: "Access Denied",
        description:
          "Generic error message when permissions are insufficient to display content",
      })}
      message={props.message}
    />
  );
}
